export const ADMIN_USERS = process.env.REACT_APP_ADMIN_USERS?.split(';') ?? [];
